import {
  SET_TRA_GOP_EDIT,
  SET_CONFIG_TM_TRA_GOP,
  SHOW_FORM_TRA_GOP,
  GET_CONFIG_SYS_TMTG,
  POST_TRA_GOP,
  POST_TRA_GOP_SUCCESS,
  POST_TRA_GOP_FAILURE,
  CHECK_EDIT_TRA_GOP,
  CHECK_EDIT_CUSTOMER_TG,
  SET_ENABLE_EDIT_TRA_GOP,
  SET_ENABLE_EDIT_CUSTOMER_TG,
  SET_TAI_SAN_TG,
  GET_TAI_SAN_THEO_CHO_VAY_TMTG,
} from './actionTypes';

export const setChoVayEdit = (dataEdit) => ({
  type: SET_TRA_GOP_EDIT,
  payload: dataEdit,
});

export const setConfig = (data) => ({
  type: SET_CONFIG_TM_TRA_GOP,
  payload: data,
});

export const showFormTraGop = (data) => {
  return {
    type: SHOW_FORM_TRA_GOP,
    payload: data,
  };
};
export const getConfigSysTMTG = (dataSearch) => ({
  type: GET_CONFIG_SYS_TMTG,
  dataSearch,
});
export const postTraGop = (dataPost) => ({
  type: POST_TRA_GOP,
  dataPost,
});

export const postTraGopSuccess = (data) => ({
  type: POST_TRA_GOP_SUCCESS,
  payload: data,
});

export const postTraGopFailure = () => ({
  type: POST_TRA_GOP_FAILURE,
});

export const checkEditChoVay = (choVayId) => ({
  type: CHECK_EDIT_TRA_GOP,
  choVayId,
});
export const setEnableEditChoVay = (data) => ({
  type: SET_ENABLE_EDIT_TRA_GOP,
  payload: data,
});

export const checkEditCustomer = (customerId) => ({
  type: CHECK_EDIT_CUSTOMER_TG,
  customerId,
});
export const setEnableEditCustomer = (data) => ({
  type: SET_ENABLE_EDIT_CUSTOMER_TG,
  payload: data,
});
export const setTaiSanTraGop = (data) => ({
  type: SET_TAI_SAN_TG,
  payload: data,
});
export const getTaiSanTheoChoVayTMTG = (dataSearch) => ({
  type: GET_TAI_SAN_THEO_CHO_VAY_TMTG,
  dataSearch,
});
